export default __webpack_public_path__ + "static/media/b16-thumb.0d5ba451.png";